import TimeDisplay from './TimeDisplay'

export default TimeDisplay
